function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M3.85 48.23a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0m-.733-27.757a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0M34.408 6.417a6.234 6.234 0 1 0 12.467 0 6.234 6.234 0 0 0-12.467 0m28.618 14.056a6.234 6.234 0 1 0 12.467 0 6.234 6.234 0 0 0-12.467 0m.228 27.757a6.234 6.234 0 1 0 12.467 0 6.234 6.234 0 0 0-12.467 0M36.72 35.007s-5.133 11.367 1.772 16.44c0 0 9.045-.672 8.19-15.157 0 0-2.75.978-5.011.367-2.262-.611-4.951-1.65-4.951-1.65",
  fill: "#BEFFFC"
}), React.createElement("path", {
  d: "M38.401 26.887a9.396 9.396 0 0 1 4.797 2.29c.452.403 2.536 2.621 3.216 5.377.31 1.256.53 2.625.53 4.12 0 4.825-1.949 9.042-4.86 11.397.51 5.997 7.36 10.32 13.532 12.437 6.417 2.2 5.318 10.817 5.318 10.817m-48.331 0s-1.1-8.617 5.317-10.817c6.173-2.117 13.022-6.44 13.534-12.437-2.913-2.355-4.861-6.572-4.861-11.398 0-6.957 4.035-11.375 9.196-11.87m-4.336 23.268s5.156 3.452 10.63 0",
  stroke: "#28348A",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M26.67 37.084s3.25-4.446 9.73-2.124c6.477 2.323 8.174 2.17 10.25.948M28.335 56.641l4.95 4.95 3.117-3.117 3.3 3.3 5.5-5.5",
  stroke: "#28348A",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M38.93 39.42a2.52 2.52 0 1 0 5.042 0 2.52 2.52 0 0 0-5.042 0zm-8.299 0a2.521 2.521 0 1 0 5.043-.002 2.521 2.521 0 0 0-5.043.001zm8.299 0s-1.645-1.166-3.257 0m-5.042 0l-4.178-1.77m17.601 1.375l2.658-1.467M.917 48.23a6.234 6.234 0 1 0 12.467 0 6.234 6.234 0 0 0-12.467 0zM.183 20.473a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0zM31.474 6.417a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0zm28.618 14.056a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0zm.228 27.757a6.234 6.234 0 1 0 12.468 0 6.234 6.234 0 0 0-12.468 0zm-35.446-9.177l-12.146 6.15m36.714-6.15l11.683 6.059M24.874 27.868l-12.651-4.706m37.219 4.706l11.306-4.522m-23.071.336V12.834M6.234 41.827V26.952m5.194-10.268L31.351 7.15m12.713.49l17.724 8.433m4.216 25.754v-15.12",
  stroke: "#28348A",
  strokeWidth: 0.4
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 76 73",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/expert_knowledge.svg